import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import {
  DownArrow,
  DropdownMenu,
  DropdownToggle,
  DropdownWrapper,
  MenuButton,
  MenuItem,
  SelectedOption,
  OptionGroupLabel
} from './styled';
import { UpArrowIcon } from '../../helpers/icon-dictionary';

const GroupedOptionsDropdown = (props) => {
  const { selectedOption, options, onSelectOption, className } = props;

  const [showMenu, setShowMenu] = useState(false);
  const containerRef = useRef(null);

  const clickListener = (event) => {
    removeDocumentClickListener(); // eslint-disable-line no-use-before-define
    if (containerRef.current && containerRef.current.contains(event.target)) {
      return;
    }
    setShowMenu(false);
  };

  const addDocumentClickListener = () => {
    document.addEventListener('mousedown', clickListener, false);
  };

  const removeDocumentClickListener = () => {
    document.removeEventListener('mousedown', clickListener, false);
  };

  const toggleMenu = () => {
    if (showMenu) {
      removeDocumentClickListener();
    } else {
      addDocumentClickListener();
    }
    setShowMenu(!showMenu);
  };

  useEffect(() => removeDocumentClickListener, []); // unmount

  const renderOptionItem = (option) => {
    const isSelected = selectedOption.value === option.value;
    return (
      <MenuItem key={option.value} selected={isSelected}>
        <button
          title={option.label}
          onClick={() => {
            onSelectOption(option);
            toggleMenu();
          }}
        >
          <React.Fragment>{option.label} </React.Fragment>
        </button>
      </MenuItem>
    );
  };

  const renderOptionGroup = optionGroup => (
    <React.Fragment key={optionGroup.groupLabel} >
      <OptionGroupLabel>{optionGroup.groupLabel}</OptionGroupLabel>
      {optionGroup.groupOptions.map(option => renderOptionItem(option))}
    </React.Fragment>
  );

  return (
    <DropdownWrapper className={className} ref={containerRef}>
      <DropdownToggle>
        <SelectedOption>
          <MenuButton onClick={toggleMenu} >
            <span>{selectedOption.label}</span>
            <DownArrow>
              <Isvg src={UpArrowIcon} cacheGetRequests />
            </DownArrow>
          </MenuButton>
        </SelectedOption>
        <DropdownMenu showMenu={showMenu}>
          <ul>{options.map(optionGroup => renderOptionGroup(optionGroup))}</ul>
        </DropdownMenu>
      </DropdownToggle>
    </DropdownWrapper>
  );
};

const optionType = PropTypes.shape({
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});

const optionGroupType = PropTypes.shape({
  groupLabel: PropTypes.string,
  groupOptions: PropTypes.arrayOf(optionType)
});

GroupedOptionsDropdown.propTypes = {
  selectedOption: optionType,
  options: PropTypes.arrayOf(optionGroupType),
  onSelectOption: PropTypes.func,
  className: PropTypes.string
};

export default GroupedOptionsDropdown;
